// extracted by mini-css-extract-plugin
module.exports = {"alert_card":"ItemTypeDetailScreen_alert_card__SpO0c","toggle":"ItemTypeDetailScreen_toggle__3-r0M","red_text":"ItemTypeDetailScreen_red_text__1EUkg"};